import { ExtremwetterschutzSelbstbeteiligung } from '@ps20/bff-models';
import { getDefaultExtremwetterschutzSelbstbeteiligung } from '@ps20-frontend/utils';
import { IAppState } from '../../../store/appState';
import { ExtremeWetterschutzSelbstbeteiligungValues } from '../../../store/models/ExtremWetterschutzSelbstbeteiligungValues.model';
import { ZusatzoptionenNameVWGEnum } from '../../../store/models/zusatzoptionenVWG.model';
import { selectSelectedProduktlinie } from './produkt.selector';

export const selectElementarSelbstbehaltId = (state: IAppState): string =>
  state.elementarSelbstbehalt ? state.elementarSelbstbehalt.id : null;

export const selectElementarSelbstbehaltDescription = (state: IAppState): string =>
  state.elementarSelbstbehalt ? state.elementarSelbstbehalt.description : null;

export const selectExetremWetterschutzSelbstbeteiligungChosenValue = (
  state: IAppState,
): ExtremwetterschutzSelbstbeteiligung => state.extremeWetterschutzSelbstbeteiligung;

export const selectExtremeWetterschutzSelbstbeteiligungValuesList = (
  state: IAppState,
): ExtremeWetterschutzSelbstbeteiligungValues[] => {
  return state.transientState.exetremeWetterschutzSelbsbeteiligungValuesList;
};

export const getDefaultSelbstbeteiligungValue = (
  state: IAppState,
): ExtremwetterschutzSelbstbeteiligung => {
  const zone = selectElementarSelbstbehaltId(state);
  return getDefaultExtremwetterschutzSelbstbeteiligung(zone);
};

export const selectExtremwetterschutzActiveValue = (
  state: IAppState,
): ExtremwetterschutzSelbstbeteiligung => {
  const isElementarSelected = selectSelectedProduktlinie(state).zusatzoptionen.find(
    zusatzoption => zusatzoption.name === ZusatzoptionenNameVWGEnum.ELEMENTAR,
  )?.isSelected;

  if (!isElementarSelected) {
    return undefined;
  }

  return selectExetremWetterschutzSelbstbeteiligungChosenValue(state);
};
